__turbopack_context__.v({
  "active": "Select-module__E8rWSW__active",
  "customSelectWrapper": "Select-module__E8rWSW__customSelectWrapper",
  "hasValue": "Select-module__E8rWSW__hasValue",
  "label": "Select-module__E8rWSW__label",
  "optionItem": "Select-module__E8rWSW__optionItem",
  "optionsList": "Select-module__E8rWSW__optionsList",
  "selectIcon": "Select-module__E8rWSW__selectIcon",
  "selectTrigger": "Select-module__E8rWSW__selectTrigger",
  "selected": "Select-module__E8rWSW__selected",
  "selectedValue": "Select-module__E8rWSW__selectedValue",
});
